import {
  isObject, isString, isArray, isFunction,
  getSessionId, getWindow, reWriteListener, getTrackedELesByUrl, getEleByXpath,
  getTime
} from '../util'
import { defaultConfig } from './config'
class ZyTrack {
  private inited = false
  config = defaultConfig
  plugins = []
  trackEles = []

  init(config: any): boolean {
    if (this.inited) return false
    const { onPageShow, onPageHide, plugins, isDefaultReport } = config

    this.setConfig(config)
    if (isArray(plugins)) plugins.forEach(options => this.install(options))

    // 重写监听器
    reWriteListener()
    if (isDefaultReport) {
      this.defaultReport()
    } else {
      this.getTrackEles()
      this.listenClickEvent()
      this.listenPageShow(onPageShow)
      this.listenPageHide(onPageHide)
    }
    this.inited = true
    return true
  }

  // 注册各类插件，可供外界调用
  install(plugin) {
    plugin.call(this)
  }

  // 数据同步方法
  send(options: any) {
    const { appId, userId, userName, teamId, teamName, host, language, screen, showLog, debug, sendMethod, serverUrl, extensibleInfo } = this.getConfig()

    const params = {
      ...options,
      appId,
      userId,
      userName,
      teamId,
      teamName,
      extensibleInfo,
      host,
      language,
      screen,
      timestamp:  getTime(),
      sessionId: getSessionId()
    }

    if (showLog) {
      const { event } = params
      console.log(`${event}事件上报内容`, params)
    }

    if (debug) return
    
    // beacon | image | ajax
    if (sendMethod === 'beacon' && navigator.sendBeacon && typeof navigator.sendBeacon === 'function') {
      try {
        const data = JSON.stringify(params)
        const blob = new Blob([data], {
          type: 'application/json; charset=UTF-8',
        });
        const result = navigator.sendBeacon(`${serverUrl}/report`, blob)
        
        // 如果 sendBeacon 返回 false（队列满了）或调用失败，降级使用 fetch
        if (!result) {
          throw new Error('sendBeacon failed')
        }
      } catch (error) {
        // sendBeacon 失败时降级到 fetch
        if (showLog) {
          console.warn('sendBeacon failed, fallback to fetch:', error)
        }
        fetch(`${serverUrl}/report`, {
          method: 'POST',
          headers:{
            'content-type':'application/json'
          },
          body: JSON.stringify(params),
        }).catch(err => {
          if (showLog) {
            console.error('fetch also failed:', err)
          }
        })
      }
    } else {
      fetch(`${serverUrl}/report`, {
        method: 'POST',
        headers:{
          'content-type':'application/json'
        },
        body: JSON.stringify(params),
      }).catch(err => {
        if (showLog) {
          console.error('fetch failed:', err)
        }
      })
    }
  }

  listenClickEvent() {
    const { isListenClick, isListenSelections } = this.getConfig()
    try {
      getWindow('document')?.addEventListener?.('click', (e: any) => {
        const target = e?.nativeEvent?.target || e?.target;
        this.getDataTrack(target)
        // 点击上报
        isListenClick && this.reportClick({
          pageUrl: location.href,
          pageTitle: document.title,
        })
        // 圈选元素判断是否被点击
        isListenSelections && this.trackEles.forEach((ele: any) => {
          const _element = getEleByXpath(ele.path as string)
          if (!_element) return
          const isContain = _element.contains(target)
          if (isContain) {
            const { element, ...data } = ele
            this.reportClick({
              ...data,
              pageUrl: location.href,
              pageTitle: document.title,
            })
          }
        })
      }, true);
    } catch (error) {
      console.error(error)
    }
  }

  getDataTrack(target) {
    if (!target) return
    const stringParams: string = target?.attributes?.['data-track']?.value;
    if (stringParams) {
      try {
        const _params = JSON.parse(stringParams)
        this.reportClick({
          pageUrl: location.href,
          pageTitle: document.title,
          ..._params
        })
      } catch (err) {
        console.log(err);
      }
    }
    if (target.parentNode) {
      this.getDataTrack(target.parentNode)
    }
  }

  // 监听圈选元素
  getTrackEles() {
    const { isListenSelections } = this.getConfig()
    if (!isListenSelections) return
    try {
      const _window = getWindow()
      const hook = async () => {
        const url = location.href
        const { serverUrl } = this.getConfig()
        const { result } = await getTrackedELesByUrl(serverUrl, url) || {}
        if (!result?.length) return
        this.trackEles = result.map(m => ({ ...m, element: getEleByXpath(m.path) }))?.filter(Boolean)
      }
      _window?.addEventListener('pageshow', hook)
      _window?.addEventListener('pushState', hook)
      _window?.addEventListener('popstate', hook)
      _window?.addEventListener('replaceState', hook)
      const destory = () => this.trackEles = []
      _window?.addEventListener('pagehide', destory)
    } catch (error) {
      console.log(error);
    }
  }

  listenPageShow(onPageShow) {
    if (isFunction(onPageShow)) {
      try {
        onPageShow((data) => {
          this.reportPV(data)
        })
      } catch(error) {
        console.error(error)
      }
    }
  }

  listenPageHide(onPageHide) {
    if (isFunction(onPageHide)) {
      try {
        onPageHide((data) => {
          this.reportPV(data)
        })
      } catch (error) {
        console.error(error)
      }
    }
  }

  // 默认上报处理
  defaultReport() {
    // let pageShowTime
    // let pageStartTime
    try {
      const _window = getWindow()
      const onPageShow = () => {
        // pageShowTime = performance.now()
        this.reportPV({
          pageUrl: location.href,
          pageTitle: document.title,
          source: {
            referrer: sessionStorage.referrer || document.referrer || '',
            type: performance?.navigation?.type || '',
          },
        })
        sessionStorage.referrer = location.href
      }
      // const onPageHide = () => {
      //   pageStartTime = performance.now() - pageShowTime
      // }
      _window?.addEventListener('pageshow', onPageShow)
      _window?.addEventListener('pushState', onPageShow)
      _window?.addEventListener('popstate', onPageShow)
      _window?.addEventListener('replaceState', onPageShow)
    } catch (error) {
      console.log(error);
    }
  }

  reportClick(data: any = {}) {
    this.send({
      event: 'click',
      data: {
        pageUrl: location.href,
        pageTitle: document.title,
        source: {
          referrer: sessionStorage.referrer || document.referrer || '',
          type: performance?.navigation?.type || '',
        },
        ...data
      }
    })
  }

  reportPV(data: any = {}) {
    this.send({
      event: 'pageView',
      data: {
        source: {
          referrer: sessionStorage.referrer || document.referrer || '',
          type: performance?.navigation?.type || '',
        },
        ...data
      }
    })
  }

  reportUV(data: any = {}) {
    this.send({
      event: 'uniqueVistor',
      data: {
        pageUrl: location.href,
        pageTitle: document.title,
        source: {
          referrer: sessionStorage.referrer || document.referrer || '',
          type: performance?.navigation?.type || '',
        },
        ...data,
      }
    })
  }

  reportCustom(data: any = {}) {
    const { event, ...others } = data || {}
    this.send({
      event,
      data: {
        pageUrl: location.href,
        pageTitle: document.title,
        source: {
          referrer: sessionStorage.referrer || document.referrer || '',
          type: performance?.navigation?.type || '',
        },
        ...others,
      }
    })
  }

  setConfig(keyOrConfig: string | any, value?: any): void {
    if (isObject(keyOrConfig)) this.config = Object.assign(this.config, keyOrConfig)
    if (isString(keyOrConfig)) this.config[keyOrConfig] = value
  }

  getConfig(key?: string): any {
    if (typeof key === 'string') return this.config[key]
    return this.config
  }
}

export { ZyTrack }
export default ZyTrack